import { render, staticRenderFns } from "./StaffInfoModal.vue?vue&type=template&id=a0f2a966&"
import script from "./StaffInfoModal.vue?vue&type=script&lang=js&"
export * from "./StaffInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports